// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"CreateConsentDocumentModal_checkboxContainer__DsjH6","checkboxTitle":"CreateConsentDocumentModal_checkboxTitle__Ulbrv"};